import cookies from "cookies-js";

export function cookieListener(cookieName, callback) {
  this.cookieRegistry = [];
  this.interval = setInterval(() => {
    return this.observe(cookieName, callback);
  }, 1000);
}

cookieListener.prototype.CREATED = "created";
cookieListener.prototype.DELETED = "deleted";
cookieListener.prototype.UPDATED = "updated";
cookieListener.prototype.observe = function(cookieName, callback) {
  var cookieVal = cookies.get(cookieName) || null,
    status = null;
  if (this.cookieRegistry[cookieName] == null && cookieVal != null) {
    status = cookieListener.prototype.CREATED;
  } else if (this.cookieRegistry[cookieName] != null && cookieVal == null) {
    status = cookieListener.prototype.DELETED;
  } else if (cookieVal !== this.cookieRegistry[cookieName]) {
    status = cookieListener.prototype.UPDATED;
  }
  this.cookieRegistry[cookieName] = cookieVal;
  if (status) callback(status);
  return status;
};

export const socialCookiesEnabled = () =>
  cookies.get("cookie_settings__social") === "true";

cookieListener.prototype.removeListener = function() {
  clearInterval(this.interval);
};



// WEBPACK FOOTER //
// ./src/cookieListener.js